/**
 * LocaleSwitcherBody
 * 
 * @Author: Focci
 * @Date: 2024-01-10 14:59:06
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-10 14:59:06
 */

// import PropTypes from 'prop-types'
import SVGLocale from '@img/locale.svg'
import SVGSort from '@img/sort.svg'
import useLocaleSwitch from '@hook/useLocaleSwitch'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'
import { useCallback } from 'react'

export function LocaleSwitcherBodyItem({
  onClick = () => {},
  ...props
}) {
  const { label, value, enName, FlagIcon, country } = props
  const tp = useTranslations('profile')
  const isCurrent = value === country
  const handleClick = useCallback(() => onClick(props), [onClick, props])

  return (
    <div
      role="button"
      onMouseDown={handleClick}
      onKeyPress={handleClick}
      tabIndex={0}
      className={clsx([
        'bg-cf8 p-3 flex items-center gap-x-2 min-w-[12rem] rounded-md',
        !isCurrent ? 'cursor-pointer hover:bg-cf0' : 'border border-helper'
      ])}
    >
      <FlagIcon width="2.5rem" height="2.5rem" />
      <div className="flex-auto">
        <b className="whitespace-nowrap text-f.9">{label}</b>
        <div className="whitespace-nowrap text-helper">
          {enName}
        </div>
      </div>
      <div 
        className={clsx([
          'pl-8 flex flex-col items-center', 
          isCurrent && 'text-primary'
        ])}
      >
        {isCurrent && <SVGLocale width=".7rem" />}
        {!isCurrent && (
          <span className="rotate-90"><SVGSort width=".7rem" /></span>
        )}
        <span className="whitespace-nowrap text-f.6">
          {isCurrent ? tp('current') : tp('change')}
        </span>
      </div>
    </div>
  )
}

export default function LocaleSwitcherBody() {
  const tp = useTranslations('profile')
  const { switchCountry, country, lang, countryOptions, flagIcon } = useLocaleSwitch()

  const handleSwitchCountry = useCallback(({ value }) => {
    value !== country && switchCountry(value)
  }, [country, switchCountry])
  
  return (
    <div className="p-4">
      <b className="whitespace-nowrap">{tp('selectCountry')}</b>
      <div className="mt-2 flex flex-col md:flex-row gap-2">
        {countryOptions.map((opt) => (
          <LocaleSwitcherBodyItem 
            key={opt.value}
            {...opt}
            FlagIcon={flagIcon[opt.value]}
            lang={lang}
            country={country}
            onClick={handleSwitchCountry}
          />
        ))}
      </div>
    </div>
  )
}

// LocaleSwitcherBody.propTypes = {
//   className: PropTypes.string,
// }
